export default __webpack_public_path__ + "static/media/rooster.669860c5.png";